import { shape, string } from "prop-types"

export const VariationShape = shape({
    variationId: string.isRequired,
    projectId: string.isRequired,
    number: string.isRequired,
    description: string.isRequired
})